// extracted by mini-css-extract-plugin
module.exports =  {"element":"_32bbee5fda--element--UtILz"};